import { Component } from '@angular/core';
import { AuthService } from '../../../shared/service/auth.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthActions } from '../../../shared/state/auth.actions';

@Component({
    selector: 'app-login',
    imports: [ReactiveFormsModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent {
  // hacer un formulario para pedir el correo
  // una ves que se tenga el corrego generar un codigo de 6 digitos  y mandarlo por mail al correo capturado
  // si el codigo esta bien el login es correcto y se activara la infomracion del uauario y se obtandra sus datos del mismo
  // borrar el codigo generado para el login del usuario
  //  guardar en session el login del usaurio  que expeire en 7 dias
  prueba = { email: 'rikimm88@gmail.com' };

  mailForm: FormGroup;
  codeForm: FormGroup;
  codeFormActive;
  login;
  timer = 5;
  interval;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private store: Store,
  ) {
    this.mailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    this.codeForm = this.fb.group({
      code: ['', [Validators.required, Validators.email]],
    });
    // if (localStorage.getItem('mmd')) {
    //   const validate: any = this.authService.getWithExpiry();
    //   if (validate) {
    //     this.router.navigate(['account', 'orders']);
    //   }

    // }
  }

  getCodeLogin() {
    // se obtiene el valor del mail y se manda a generar el codigo con el mail,validad que exista el mail
    this.authService.postCreateCode(this.mailForm.value).subscribe((res) => {
      this.codeFormActive = res.mail;
      Object.assign(this.prueba, res);
    });
  }
  validateLogin() {
    // se valida el codigo para hacer el login
    const code = {};
    Object.assign(code, this.mailForm.value);
    Object.assign(code, this.codeForm.value);
    this.authService.postValidate(code).subscribe((res) => {
      //
      this.login = res.login;
      this.authService.setWithExpiry();
      this.store.dispatch(new AuthActions.Set({ login: true, email: this.mailForm.value.email, mmd: res.id_firebase, address: res.address }));

      this.interval = setInterval((res) => {
        this.timer -= 1;
        if (this.timer === 0) {
          clearInterval(this.interval);
          // alert('redirecionando')
          this.router.navigate(['account', 'orders']);
        }
      }, 1000);
    });
  }
}
